import { decode } from "js-base64";
import axios from "axios";

export function decodeToken(token) {
  if (!token) return null;

  const payload = token.split(".")[1];
  if (!payload) return null;

  const decodedPayload = decode(payload);
  const payloadObject = JSON.parse(decodedPayload);

  return payloadObject;
}

export function getOrganizationFromToken() {
  try {
    const token = localStorage.getItem("token");
    return decodeToken(token)?.organization ?? null;
  } catch (e) {
    return null;
  }
}

function checkTokenExpired(token) {
  const decodedToken = decodeToken(token);
  if (!decodedToken) return true;

  const exp = decodedToken.exp;
  const currentTime = Date.now() / 1000;
  return exp < currentTime;
}

export function deleteToken() {
  localStorage.removeItem("token");
  localStorage.removeItem("refresh_token");
}

export function handleInvalidToken() {
  deleteToken();
  window.alert("올바르지 않은 토큰 정보입니다. 다시 로그인해주세요.");
  window.location.href = "/login";
}

async function refreshToken() {
  const refreshToken = localStorage.getItem("refresh_token");
  if (!refreshToken) return false; // 리프레시 토큰 없음  -> 로그인 페이지로 이동

  const isRefreshTokenExpired = checkTokenExpired(refreshToken);
  if (isRefreshTokenExpired) {
    // 리프레시 토큰 만료
    deleteToken();
    window.alert("로그인 시간이 만료되었습니다. 다시 로그인해주세요.");
    return false; // 로그인 페이지로 이동
  }

  // 리프레시 토큰을 사용한 재발급
  try {
    const res = await axios.post(`${process.env.REACT_APP_API_URL}/auth/refresh`, {
      expiredAccessToken: localStorage.getItem("token"),
      refreshToken,
    });

    if (!res?.data?.success) {
      // 토큰 재발급 실패
      deleteToken();
      window.alert(
        res?.data?.message ?? "로그인 시간이 만료되었습니다. 다시 로그인해주세요.",
      );
      return false; // 로그인 페이지로 이동
    }

    // 토큰 재발급 성공
    localStorage.setItem("token", res.data.data.accessToken);
    localStorage.setItem("refresh_token", res.data.data.refreshToken);
    return true;
  } catch (err) {
    // 토큰 재발급 실패
    console.log(err);
    deleteToken();
    window.alert(
      err?.response?.message ?? "로그인 시간이 만료되었습니다. 다시 로그인해주세요.",
    );
    return false; // 로그인 페이지로 이동
  }
}

// 토큰 유효성 체크
export async function checkTokenValid() {
  const token = localStorage.getItem("token");
  if (!token) return false; // 토큰 없음 -> 로그인 페이지로 이동

  const isTokenExpired = checkTokenExpired(token);
  if (!isTokenExpired) return true; // 토큰 유효

  // 토큰 만료
  return await refreshToken();
}
